<template>
	<div class="visor-marketing-page-main">
		<div class="content-area">
			<div class="top-header">
				<div class="header-section left-header">
					<a :href="VisorGlobalConfig.externalLinks.marketingHomepage">
						<img :src="require('assets/visor-branding/visor-wordmark-on-dark.svg')" class="visor-wordmark" title="Visor" />
					</a>
				</div>
				<div
					v-if="$route && $route.name !== 'waitlist'"
					class="header-section right-header"
				>
					<r-button
						theme="white-outline"
						size="large"
						@click="earlyAccess"
					>
						Get Early Access
					</r-button>
				</div>
			</div>
			<div class="body">
				<slot />
			</div>
			<div class="footer">
				&copy; {{(new Date()).getYear() + 1900}} RocketVisor Corporation. All rights reserved.
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		$pubsub:{
			routerNavigation:{
				subscriptions:{
					beforeRouteChanged(){
						this.$el.scrollTo(0, 0);
					}
				}
			}
		},
		data(){
			return {

			};
		},
		props:{

		},
		created(){

		},
		mounted(){

		},
		watch:{

		},
		computed:{

		},
		methods:{
			earlyAccess(){
				window.location.href = "/waitlist";
			}
		},
	}

</script>

<style lang="scss" scoped>

	@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);

	.visor-marketing-page-main{

		font-family: 'Inter', sans-serif;

		background: $p-color-black;
		color: $p-color-white;
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		overflow: auto;

		.content-area{
			max-width: 1200px;
			margin: auto;

			.top-header{
				height: 72px;
				display: flex;
			    justify-content: space-between;
			    align-items: center;
			    position: sticky;
			    top: 0;
			    left: 0;
			    background: $p-color-black;
			    z-index: 1;

			    .header-section{
			    	padding: 12px;

			    	&.left-header{

			    		.visor-wordmark{
			    			height: 30px;
			    			width: 132px;
			    		}

			    	}

			    	&.right-header{

			    	}
			    }
			}

			.body{
				padding: 0 12px;
			}

			.footer{
				padding: 120px 12px 24px 12px;
				color: $p-color-grey-300;
			}
		}
	}

</style>
